import {ChangeEventHandler, ReactNode} from 'react';
import ShopFilterToggleContainer from './ShopFilterToggleContainer.client';

interface ShopFilterSelectProps {
  title: string;
  name: string;
  options: {value: string; label: ReactNode}[];
  values: Array<string>;
  onChange: ChangeEventHandler<HTMLInputElement>;
  children?: ReactNode;
  hasReadMoreBlock?: boolean;
  hideIfEmpty?: boolean;
}

export default function ShopFilterSelect({
  title,
  name,
  options,
  values,
  onChange,
  children,
  hasReadMoreBlock = false,
  hideIfEmpty = true,
}: ShopFilterSelectProps) {
  return !hideIfEmpty || options.length > 0 ? (
    <ShopFilterToggleContainer
      title={title}
      hasReadMoreBlock={hasReadMoreBlock && options.length > 10}
    >
      {options.map(({label, value}) => (
        <label
          key={value}
          className="checkbox shop-filter__checkbox search-filter-item-js"
        >
          <input
            type="checkbox"
            name={name}
            className="checkbox__input"
            value={value}
            checked={values.includes(value)}
            onChange={onChange}
          />
          <span className="checkbox__content search-filter-item-text-js">
            {label}
          </span>
        </label>
      ))}
      {children}
    </ShopFilterToggleContainer>
  ) : null;
}
